import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import StyledSvgIconWrapper from "./wrappers/StyledSvgIconWrapper";
import theme from "@monorepo/styles/theme";

export const DeleteIcon = (props: SvgIconProps) => {
  return (
    <StyledSvgIconWrapper
      {...props}
      width="24"
      height="23.2"
      viewBox="0 0 24 23.2"
      stroke={props.stroke ?? theme.palette.primary.main}
    >
      <svg width="31" height="32" viewBox="0 0 31 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_260_228)">
          <path
            d="M8.38193 6.66583C8.38193 6.66583 9.73679 3.08807 10.03 2.44847C10.3232 1.80887 11.3242 0.98938 12.8206 0.98938H18.2906C19.6758 0.98938 20.7476 1.80887 21.0408 2.44847C21.334 3.08807 22.608 6.61586 22.608 6.61586"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="stroke"
          />
          <path
            d="M19.8679 25.9338V11.1331"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="stroke"
          />
          <path
            d="M11.1321 25.9338V11.1331"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="stroke"
          />
          <path
            d="M1.01109 6.67587L29.9889 6.65588"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="stroke"
          />
          <path
            d="M27.35 7.59521L26.1973 25.3441C26.1973 28.4722 23.6494 31.0106 20.5049 31.0106H10.4041C7.25962 31.0106 4.71167 28.4722 4.71167 25.3441L3.74103 7.59521"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="stroke"
          />
        </g>
        <defs>
          <clipPath id="clip0_260_228">
            <rect width="31" height="32" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </StyledSvgIconWrapper>
  );
};
